import gql from 'graphql-tag'
import _ from 'lodash'
import Model, { ID, Integer, IsoDateTime, JsonArray, JsonObject, MODEL_LEVEL } from 'src/models/Model'
import Modifier from 'src/models/modifier-set/Modifier'

export default class ModifierSet extends Model {
  static name = 'ModifierSet'

  static isConfiguration = true

  static duplicatable = true

  static paginate = true

  static deletable = true

  static versioned = true

  static level = MODEL_LEVEL.SITE

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Concession]

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true
      },
      action: {
        type: String,
        input: true
      },
      modifiers: {
        type: [Modifier],
        reference: true,
        acceptsNestedAttributes: true,
        allowDestroy: true
      },
      name: {
        type: String,
        required: true,
        translatable: true
      },
      displayOrder: {
        type: Integer,
        default: 100
      },
      availableOnline: {
        type: Boolean,
        default: true
      },
      multiselect: {
        type: Boolean,
        default: true
      },
      printingOptions: {
        type: JsonObject,
        default: () => ({
          print_name: true
        })
      },
      archivedAt: {
        type: IsoDateTime,
        output: true
      },
      libraryParentId: {
        type: ID,
        output: true,
        excludeFromDefault: true
      },
      receiveLibraryUpdates: {
        type: Boolean,
        excludeFromDefault: true
      },
      libraryChildSiteIds: {
        type: [ID],
        output: true,
        excludeFromDefault: true
      },
      libraryDescendantSites: {
        type: JsonArray,
        output: true,
        excludeFromDefault: true
      }
    }

    this.computed = {
      activeModifiers () {
        return _.filter(this.modifiers?.data, { active: true })
      }
    }
  }

  get description () {
    return _.map(this.modifiers, 'description').join(', ')
  }

  get isAvailableOnline () {
    return this.availableOnline && _.some(this.modifiers.data, 'availableOnline')
  }

  get onlineModifiers () {
    return _.filter(this.modifiers.data, 'availableOnline')
  }

  get fetchGql () {
    return gql`
      query($id: ID!) {
        modifierSet(id: $id) {
          id
          name
          displayOrder
          multiselect
          modifiers {
            id
            name
            displayOrder
            price {
              amount
            }
          }
        }
      }
    `
  }
}
